import { useEffect } from "react";

var useUmamiScript = function useUmamiScript(src, websiteId) {
  useEffect(function () {
    var script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = src;
    script.setAttribute("data-website-id", websiteId);
    document.head.appendChild(script);
    return function () {
      document.head.removeChild(script);
    };
  }, [src, websiteId]);
};

export default useUmamiScript;